import {Modal, Form, Button, Row, Col} from 'react-bootstrap';
import {useState, useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import API from '../helpers/api';

export default function CreateUpdateAgentModal({show, close, agent}){
    const dispatch = useDispatch();
    const api = useMemo(() => new API({dispatch}), [dispatch]);
    const [formData, setFormData] = useState(() => {
        if (agent) return agent;
        return {
            first_name: '',
            last_name: '',
            email: '',
            user_password: '',
            is_admin: false,
            is_active: true
        }
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (agent) {
            setFormData(agent);
        } else {
            setFormData({
                first_name: '',
                last_name: '',
                email: '',
                user_password: '',
                is_admin: false,
                is_active: true
            });
        }
    }, [agent]);

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            if (agent) {
                await api.updateAgent(formData);
            } else {
                await api.createAgent(formData);
            }
            close();
        } catch (error) {
            alert("Error Creating/Updating Agent");
            console.error('Error submitting form:', error);
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <Modal show={show} onHide={close}>
            <Modal.Header closeButton>
                <Modal.Title>{agent ? 'Update Agent' : 'Create Agent'}</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="firstName">
                                <Form.Label>First Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="first_name"
                                    value={formData.first_name}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="lastName">
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="last_name"
                                    value={formData.last_name}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="email">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        {!agent && (
                        <Col>
                            <Form.Group controlId="userPassword">
                                <Form.Label>User Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="user_password"
                                    value={formData.user_password}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        )}
                    </Row>

                    <Row>
                        <Col>
                            <Form.Group controlId="isAdmin">
                                <Form.Check
                                    type="checkbox"
                                    label="Is Admin"
                                    name="is_admin"
                                    checked={formData.is_admin}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col>
                            <Form.Group controlId="isActive">
                                <Form.Check
                                    type="checkbox"
                                    label="Is Active"
                                    name="is_active"
                                    checked={formData.is_active}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={close}>
                        Close
                    </Button>
                    <Button type="submit" variant="primary" disabled={isSubmitting}>
                        {isSubmitting ? 'Submitting...' : 'Submit'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}